import axios from "axios";
import url from "../../helpers/url";

async function HandleLogin({ username, password, errors, setErrors }) {
  const response = await axios
    .post(`${url}/auth/local`, {
      identifier: username,
      password: password,
    })
    .catch((error) => {
      const data = { error };
      setErrors({
        ...errors,
        error_login: data.error.response.data.data[0].messages[0].message,
      });
    });
  return response;
}

export default HandleLogin;
